/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES プレスリリースエディタ API
 * PR TIMES 企業管理画面 プレスリリースエディタ用の API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    GetPixtaCategorySuccessResponseData,
    GetPixtaCategorySuccessResponseDataFromJSON,
    GetPixtaCategorySuccessResponseDataFromJSONTyped,
    GetPixtaCategorySuccessResponseDataToJSON,
} from './GetPixtaCategorySuccessResponseData';

/**
 * GET /press_release/pixta/category
 * @export
 * @interface GetPixtaCategoryResponse
 */
export interface GetPixtaCategoryResponse {
    /**
     * 
     * @type {number}
     * @memberof GetPixtaCategoryResponse
     */
    status: number;
    /**
     * 
     * @type {string}
     * @memberof GetPixtaCategoryResponse
     */
    message: string;
    /**
     * 
     * @type {GetPixtaCategorySuccessResponseData}
     * @memberof GetPixtaCategoryResponse
     */
    data: GetPixtaCategorySuccessResponseData;
}

export function GetPixtaCategoryResponseFromJSON(json: any): GetPixtaCategoryResponse {
    return GetPixtaCategoryResponseFromJSONTyped(json, false);
}

export function GetPixtaCategoryResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetPixtaCategoryResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'message': json['message'],
        'data': GetPixtaCategorySuccessResponseDataFromJSON(json['data']),
    };
}

export function GetPixtaCategoryResponseToJSON(value?: GetPixtaCategoryResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'message': value.message,
        'data': GetPixtaCategorySuccessResponseDataToJSON(value.data),
    };
}

